<template>
  <div class="home">
    <h2>Historique des inventaires</h2>
      <el-alert
        title="information"
        type="info"
        description="Vous pouvez consulter l'historique des inventaires en
        filtrant par inventaire."
        show-icon>
      </el-alert>
      <div class="select-container">
      <label>Sélectionnez un inventaire : </label>

      <el-select v-model="valueSelected" placeholder="Select">
        <el-option
          v-for="inventaire in listingInvetaireHead"
          :key="inventaire.inventoryId"
          :label="inventaire.dateBeg+' - '+inventaire.dateEnd"
          :value="inventaire.inventoryId">
          <span style="float: left">Inventaire du
          {{ inventaire.dateBeg }} au {{ inventaire.dateEnd }}</span>
        </el-option>
      </el-select>
    </div>
    <div v-loading="loading">
    </div>
    <el-alert
      :title="typeInventaire"
      type="warning">
    </el-alert>
    <ListInventory
      :inventoryId="valueSelected"
      :list="listInventory"
      @onImportInventaireHistory="importInventaireHistory"
    />
  </div>
</template>

<script>
// @ is an alias to /src
import services from 'services';
import _ from 'lodash';
import ListInventory from '@/components/Inventaire/ListHistoriqueInventaire.vue';

export default {
  components: {
    ListInventory,
  },
  async mounted() {
    this.loading = true;
    this.listingInvetaireHead = await services.InventaireService.getInventairesHead();
    // const firstProductId = 'B000';
    const firstInventaireId = this.listingInvetaireHead[0] !== undefined
      ? this.listingInvetaireHead[0].inventoryId : null;
    this.valueSelected = firstInventaireId;
  },
  watch: {
    valueSelected(value) {
      this.loading = true;
      this.$store.dispatch('inventaire/fetchInventaireByIdAndStore', { inventaireId: value });
      // console.log('this.listInventory');
      // console.log(this.listInventory);
      console.log('this.listingInvetaireHead');
      console.log(this.listingInvetaireHead);
      this.loading = false;
    },
  },
  computed: {
    listInventory() {
      return this.$store.getters['inventaire/listInventaireProducts'];
    },
    typeInventaire() {
      const inventaireHeadSelected = _.find(this.listingInvetaireHead,
        (i) => i.inventoryId === this.valueSelected);
      console.log('inventaireHeadSelected');
      console.log(inventaireHeadSelected);
      const inventoryType = _.get(inventaireHeadSelected, 'inventoryType', 'INV_CLASSIQUE');
      let value = '';
      if (inventoryType === 'INV_CLASSIQUE') {
        value = 'Inventaire fin de mois ';
      } else {
        value = 'Inventaire produit et hygiene ';
      }
      return value;
    },
  },
  data() {
    return {
      loading: false,
      listingInvetaireHead: [],
      valueSelected: '',
      // valConso: 0,
      // listInventory: [],
      // fakeCustomers: [],
    };
  },
  methods: {
    async importInventaireHistory() {
      const loader = this.$loading({
        lock: true,
        text: "Importaion de l'inventaire en cours",
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      const shopId = this.$store.getters['shopAuth/currentShopId'];
      await services.InventaireService.importHistory(this.valueSelected, shopId);
      this.$store.dispatch('inventaire/fetchInventaireByIdAndStore', { inventaireId: this.valueSelected });
      // this.displayingMessageImport = 2;

      loader.close();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">

$margin = 25px;

.select-container
  margin: $margin;

h2
  margin: 15px $margin;

.el-alert {
    margin: $margin;
    width: 80%;
}
</style>
